"use client";
import styles from "./index.module.scss";
import { useEffect, useRef, useState } from "react";
import { Image, Input, Menu, Popover } from "antd";
import { AppstoreOutlined, RightOutlined, MessageFilled } from "@ant-design/icons";
import CancelAuthModal from "@/components/CancelAuthModal";
import SizeBox from "@/components/SizeBox";
import { getQueryString, isMobile } from "@/utils/action";
import Footer from "@/components/Footer";

function getItem(label, key, icon, children, type, body) {
  return {
    key,
    icon,
    children,
    label,
    type,
    body
  };
}

function flattenSecondaryItems(items) {
  const result = [];

  function traverse(item) {
    if (item.children && item.children.length > 0) {
      item.children.forEach(child => {
        // 使用正则表达式去掉label前的数字
        const cleanLabel = child.label.replace(/^\d+\.\d+\s*/, '');
        result.push({ title: cleanLabel, key: child.key });
      });
    }
  }

  items.forEach(traverse);
  return result;
}

function waitForElement(id, timeout = 1000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const check = () => {
      const el = document.getElementById(id);
      if (el) return resolve(el);

      if (Date.now() - start > timeout) return reject('Element not found');
      requestAnimationFrame(check);
    };

    check();
  });
}

const waitForImagesLoaded = () => {
  return new Promise((resolve) => {
    if (document.readyState === 'complete') {
      // 页面和图片都加载完了
      resolve();
    } else {
      window.addEventListener('load', () => {
        resolve();
      });
    }
  });
};


const waitForElementStable = (id, maxWaitTime = 5000) => {
  return new Promise((resolve, reject) => {
    let lastHeight = 0;
    let sameCount = 0;
    const start = Date.now();

    const check = () => {
      const el = document.getElementById(id);
      if (!el) {
        if (Date.now() - start > maxWaitTime) {
          reject();
        } else {
          requestAnimationFrame(check);
        }
        return;
      }

      const currentHeight = el.offsetHeight;
      if (currentHeight === lastHeight) {
        sameCount++;
      } else {
        sameCount = 0;
        lastHeight = currentHeight;
      }

      if (sameCount >= 10) {
        // 连续10次高度没变，认为稳定了
        resolve(el);
      } else if (Date.now() - start > maxWaitTime) {
        reject();
      } else {
        requestAnimationFrame(check);
      }
    };

    check();
  });
};



const HelpCenter = () => {
  const [isClient, setIsClient] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [currentIndex, setCurrentIndex] = useState("0");
  const [randomList, setRandomList] = useState([]);
  const [outLoginVisible, setOutLoginVisible] = useState(false);

  const items = [
    {
      key: '0',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/1.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: 'Welcome',
      children: null
    },
    {
      key: '1',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/6.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: "1. New User Guidance",
      children: [{
        key: '1.1',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/7.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "1.1 Select Products",
        text: <div>
          <div>We provide search (support product name and product link search), filtering, sorting and other functions to help you quickly find the products you are satisfied with!</div>
          <div className={`${styles.guideBox}`}>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/search1.png"} />
            </div>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/search2.png"} />
            </div>
          </div>
        </div>
      },
      {
        key: '1.2',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/8.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "1.2 Add to Showcase",
        text: <div className={styles.contentText}>Our platform allows add to showcase of individual items and batch add to showcase of multiple items <br />
          <ul>
            <li>Click the [Add] button in the product. 1.If you use the device for the Web, scan the QR code in the pop-up window or copy the link below to the mobile browser to open it. 2.If you are a cell phone, you can jump directly to add the cabinet of the product you are satisfied with.</li>
            <li>You can view your favorite products on the “My Collection” page, and you can select multiple products and click [Batch Add to Showcase] to add them to your showcase, which is fast and convenient!</li>
          </ul>
          <div className={styles.guideBox}>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/showcase1.png"} />
            </div>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/showcase2.png"} />
            </div>
          </div>
        </div>
      },
      {
        key: '1.3',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/9.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "1.3 Get Samples",
        text: <div>
          Cick the [Sample] button to request a sample, and check the pop-up window for instructions. If you don't find the free sample button on the TikTok page, click [Request Sample Offline] and fill out the information form to request a sample offline for you, provided that you are a member of our platform's Creator Affiliate Program.<br />
          <div className={styles.guideBox}>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/samples1.png"} />
            </div>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/samples2.jpg"} />
            </div>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/samples3.jpg"} />
            </div>
          </div>
        </div>
      },
      {
        key: '1.4',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/10.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "1.4 Unlock the Highest Commission Rate",
        text: <div>In "My Profile",there is a dedicated signing portal, click [Unlock Highest Commission]---[Obtain Eligibility] for signing operation, we will send a signing invitation to your TikTok within 24 hours, please pay attention to the message to receive and  accept the request. If you want to know if you've signed, click [I'm already eligible] to refresh your signing status.</div>
      },
      {
        key: '1.5',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/11.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "1.5 Increase Commission",
        text: "If your showcase product has a higher commission rate on our platform, we will push it for you and you can change to a higher commission rate."
      }]
    },
    {
      key: '2',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/12.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: "2. Q&A for Accounts",
      children: [{
        key: '2.1',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/13.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "2.1 Why does the login fail?",
        text: <div>
          The first time you log in, when you see the “anystarr wants to access your TikTok account” page, please check all the authorization information and click the Continue button. If you don't check all the authorization information, your login will fail.<br />
          <div className={styles.guideBox}>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/login1.jpg"} />
            </div>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/login2.jpg"} />
            </div>
          </div>
        </div>
      },
      {
        key: '2.2',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/14.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "2.2 How to authorize or cancel authorization？",
        text: <div className={styles.contentText}>
          <div style={{ fontWeight: '700' }}>Authorize：</div>
          <div className={styles.guideBox}>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/authorize1.jpg"} />
            </div>
            <div>
              <Image className={"lg:!h-[700px] lg:!w-full"} src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/authorize2.jpg"} />
            </div>
          </div>
          <div style={{ fontWeight: '700' }}>Cancel Authorization：</div>
          <div>If you want to cancel the authorization, click the button below, but be careful:</div>
          <ul>
            <li>Please make sure that the Tiktok account you logged in on your webpage or App is the same as the one you logged in at anyStarr, otherwise the cancelling will fail!</li>
            <li>After canceling the authorization, many functions will be disabled.Please consider carefully！</li>
          </ul>
          <div className={styles.cancel} onClick={() => setOutLoginVisible(!outLoginVisible)}>Cancel Authorization</div>
        </div>
      }]
    },
    {
      key: '3',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/15.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: "3. Q&A for Creator Affiliate Program",
      children: [{
        key: '3.1',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/16.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "3.1 Why join our Creator Affiliate Program?",
        text: <div className={styles.contentText}>
          <div>After joining our Creator Affiliate Program, you’ll enjoy: </div>
          <ul>
            <li>Our Highest Commissions on every product (ranging from 12%-30%)</li>
            <li>Offline samples</li>
            <li>Exclusive Extra View Boost</li>
            <li>Personalized 1v1 support</li>
            <li>TikTok Flash Sales</li>
          </ul>
        </div>
      },
      {
        key: '3.2',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/17.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "3.2 How to join our Creator Affiliate Program?",
        text: <div>
          You can go through the following steps to join our Creator Affiliate Program:
          <ol>
            <li>When the window inviting you to join our Creator Affiliate Program pops up, click the Obtain Eligibility button.</li>
            <li>We'll send you a Linking Invite and more partner details from our affiliate account Uango to your TikTok. </li>
            <li>Simply check the link we sent and accept the request!</li>
          </ol>
        </div>
      }]
    },
    {
      key: '4',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/18.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: "4. Q&A for Samples",
      children: [{
        key: '4.1',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/19.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "4.1 What if the Tiktok Promotion Info page doesn't have a Get Free Sample button?",
        text: <div>
          <div style={{ fontWeight: '700' }}>There may be 2 reasons why your Tiktok Promotion Info page does not have a Get Free Sample button:</div>
          <ol>
            <li> You do not meet the eligibility requirements set by the merchant or affiliate partner to request a free sample.The thresholds may include: </li>
          </ol>
          <div style={{ textIndent: '2em' }}>a. Minimum follower count</div>
          <div style={{ textIndent: '2em' }}>b. Minimum gmv</div>
          <div style={{ textIndent: '2em' }}>c. Average ecommerce video views</div>
          <div style={{ textIndent: '2em' }}>d. Category</div>
          <div style={{ textIndent: '2em' }}>e. Predicted fulfillment rank</div>
          <div>2. Your quota for free samples has run out.</div>
          <div style={{ fontWeight: '700', marginTop: '20px' }}>You can get free samples in the following other ways:</div>
          <ol>
            <li>Try requesting samples of other similar products.</li>
            <li>Send a video with the samples you have previously requested. The quota will be released after posting the video, then you can use the released quota to request more free samples.</li>
            <li>The quota limit is refreshed once a month. You can wait for the next quota refresh to request free samples.</li>
            <li>Join our <span style={{ fontWeight: '700' }}>Creator Affiliate Partner</span> to get offline sample qualification. If you have already joined, you can directly click the Request Sample Offline button to request offline samples, and we will help you request free samples directly from the merchants.</li>
          </ol>
          <div style={{ fontWeight: '700', marginTop: '20px' }}>The quota of free samples you can request depends on your monthly GMV:</div>
          <ol>
            <li>creators with a monthly GMV of less than $5,000 can request up to 5 free samples.</li>
            <li>Creators with a monthly GMV between $5,000 and $150,000 can request up to 20 free samples.</li>
            <li>Creators with a monthly GMV of over $150,000 can request up to 50 free samples.</li>
          </ol>
          <div>(The quota includes any sample requests that are under review, awaiting shipment, or have pending content.)</div>
        </div>
      },
      {
        key: '4.2',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/20.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "4.2 How to request free samples offline?",
        text: <div>
          <div>You can go through the following steps to request free samples offline:</div>
          <ol>
            <li>Click the Sample button on the product card or product detail page.</li>
            <li>When the Get Sample window pops up, click the Request Sample Offline button at the bottom.</li>
            <li>If you have joined our Creator Affiliate Program, a Filling Information window will pop up. Fill in the correct information and click the Submit button.</li>
            <li>If the window inviting you to join our Creator Affiliate Program pops up, please click the Obtain Eligibility button to join us before you can request the offline sample. If you have already joined our Creator Affiliate Program, please click the I'm already eligible button to refresh your data.</li>
          </ol>
          <div>If your sample request is approved and sent out by the merchant, we will notify you within a week via email /anyStarr US/ Befriends SSG US/ Uango and shop account tagged with anyStarr. We'll also include the courier number where the sample was sent, so you can check it out at any time!</div>
          <div style={{ fontWeight: '700' }}>PLEASE NOTE：</div>
          <ol>
            <li>Your sample request will be forwarded to the merchant and reviewed by the merchant based on your online fulfillment performance and gmv sales. anyStarr cannot guarantee that your sample request will be reviewed and approved. You can increase your chances of approval by posting more videos of the samples you have received and improving your profile and e-commerce information settings.</li>
            <li>Posting a sample-related video within 1-2 weeks of receiving a sample will greatly increase the probability of receiving your next offline sample.</li>
          </ol>
        </div>
      },
      {
        key: '4.3',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/21.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "4.3 How to fulfill your request for a free sample?",
        text: <div>
          <div>Try out the samples provided by the merchant and complete fulfillment by posting a short video for at least 3 days or a LIVE of approximately 10 minutes in length to share your thoughts!</div>
          <div style={{ fontWeight: '700' }}>PLEASE NOTE：</div>
          <div>Fulfillment rates may affect your approval rate for subsequent sample requests, so please be active in posting content!</div>
        </div>
      },
      {
        key: '4.4',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/22.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "4.4 What if the samples are out of stock?",
        text: <div className={styles.contentText}>
          <ul>
            <li>If the product is sold out, the merchant will restock it within 48 hours.</li>
            <li>If the sold out product is not restocked or if you need it urgently, you can contact us to get it restocked by the merchant.</li>
            <li>If the product is off the shelf or out of stock, try to find a similar item.</li>
          </ul>
        </div>
      }]
    },
    {
      key: '5',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/23.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: "5. Q&A for Products",
      children: [{
        key: '5.1',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/24.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "5.1 How do I know the quality of products?",
        text: "You can directly assess the quality with suppliers or check on customer reviews of the product."
      },
      {
        key: '5.2',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/25.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "5.2 Why did I receive the wrong product/not mine?",
        text: <div>
          <div>There are two reasons: </div>
          <ol>
            <li>The seller sent the wrong product, please freely contact us or the seller for a replacement. </li>
            <li>You may check your fulfillment list on TikTok to confirm since you may have authorized us to automatically send the sample.</li>
          </ol>
        </div>
      },
      {
        key: '5.3',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/26.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "5.3 Why did I receive the product fulfillment message from you?",
        text: "In this case, as we collaborate with the supplier who sends you samples, please feel free to contact us with any requests."
      },
      {
        key: '5.4',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/27.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "5.4 What can I do if the product is broken?",
        text: "If the package is broken, please freely contact the carrier or the seller. If the product is broken, please freely contact the seller."
      }]
    },
    {
      key: '6',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/28.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: "6. Q&A for Commissions",
      children: [{
        key: '6.1',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/29.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "6.1 Why switching to a higher commission rate didn't get you a higher commission?",
        text: "Commissions earned from video banding will need to be re-posted after changing to a higher commission rate to take effect."
      },
      {
        key: '6.2',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/30.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "6.2 How to get a higher commission rate?",
        text: <div>
          <div>There are four ways you can get a higher commission rate:</div>
          <ol>
            <li>Use the Commission Increase feature. We'll push you the same products as in your showcase, but at a higher commission! </li>
            <li>Use the product's Similarity Recommendation function to find similar products with higher commissions.</li>
            <li>Join our Creator Affiliate Program and enjoy our full commission rate!</li>
            <li>Contact us and we will assist you with adjustments.</li>
          </ol>
        </div>
      },
      {
        key: '6.3',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/31.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "6.3 How to get an ad code?",
        text: <div>
          <div>Typically, we require your ad code to help boost your video.</div>
          <div>The steps are fairly simple:</div>
          <div>Step 1: Please go to the video on their page to be promote</div>
          <div>Step 2: Click the ••• below the “comment” button</div>
          <div>-Select “Ad settings”</div>
          <div>-Toggle Ad authorization to “On” and agree to the terms</div>
          <div>-Click Generate code</div>
          <div>-And copy > share the code with you, the advertiser</div>
          <div>It is recommend 30 or 60 days depending on what the creator agrees to.</div>
          <Image src={"https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help_center.jpeg"} />
        </div>
      }]
    },
    {
      key: '7',
      icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/32.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
      label: "7. Q&A for Logistics",
      children: [{
        key: '7.1',
        icon: <img src={`https://anystarr-image.oss-ap-southeast-1.aliyuncs.com/help-center/33.png`} style={{ marginRight: "5px" }} width={25} height={25} />,
        label: "7.1 Why haven't I received my package?",
        text: "Please kindly check your sample's status. If it hasn't been sent out within 72 hours, please freely contact us. If it shows delivery or not updated for a long time, we suggest contacting the carrier to check the package first."
      }]
    },
  ];
  function getRandomItems(list, count) {
    const shuffled = [...list].sort(() => 0.5 - Math.random()); // 打乱数组顺序
    return shuffled.slice(0, count); // 取前 `count` 个元素
  }

  useEffect(() => {
    setIsClient(true);
    setMobile(isMobile());
    setShowMenu(!isMobile());
  }, []);
  useEffect(() => {
    const flatList = flattenSecondaryItems(items);
    setRandomList(getRandomItems(flatList, 4));
  }, [currentIndex]);


  useEffect(() => {
    const key = getQueryString("key");
    setTimeout(()=>{
      onMenuClick({ key });
    }, 1200);
  }, []);

  const onMenuClick = async (e) => {
    setCurrentIndex(e.key);
    if (mobile) {
      setShowMenu(false);
    }
    await waitForImagesLoaded(); // 💥 等图片全部加载完！

    setTimeout( async  () => {
      const target = await waitForElementStable(e.key);
      if (target) {
        // const headerHeight = document.querySelector('.navbar').offsetHeight; // 获取导航栏的高度

        // 使用 scrollIntoView 滚动到目标元素，并添加偏移量
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });

        // 调整页面位置，确保目标元素下方有足够空间
        // window.scrollBy(0, -200); // 向上滚动导航栏的高度，确保目标元素下方有空间
      }
    }, 0);
  };

  if (!isClient) {
    return null; // Show a loading indicator or null during server-side rendering
  }


  const openEmail = () => {
    const email = 'contact@anystarr.com';
    const subject = 'To anystarr';
    const body = '';

    // 使用mailto协议打开默认的电子邮件客户端
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // 打开邮件客户端
    window.location.href = mailtoLink;
  };

  return <div className={styles.help_page}>
    <div className={`${styles.nav_wrap} ${showMenu ? styles.show_menu : ""}`}>
      <div>
        <Menu
          inlineCollapsed={!showMenu}
          onClick={onMenuClick}
          defaultSelectedKeys={['0']}
          defaultOpenKeys={['0']}
          mode={"inline"}
          items={items}
        />

        {
          mobile && <div onClick={() => setShowMenu(!showMenu)} className={`${showMenu ? styles.menuBotton : styles.unShowMenu}`}>
            {
              showMenu ? "Fold up navigation" : <RightOutlined style={{ color: '#fff' }} />
            }
          </div>
        }
      </div>
      {
        !mobile && <div onClick={openEmail} className={styles.contact_us_txt}> Contact us </div>
      }
    </div>
    <div id={"body-warp"} className={`${styles.body_wrap} ${showMenu ? styles.body_wrap_show_menu : ""}`}>

      {
        currentIndex === "0" ? <>
          <WelcomeComp mobile={mobile} onMenu={(item) => onMenuClick(item)} randomList={randomList} items={items}></WelcomeComp>
          <SizeBox h={30}></SizeBox>
          <div className={styles.popular_wrap}>
            <div className={styles.popular_title}>Popular question</div>
            {
              randomList.map((item, index) => {
                return <div key={index} onClick={() => onMenuClick(item)} className={styles.popular_item}>{item.title}</div>;
              })
            }
          </div>
          <SizeBox h={30}></SizeBox>
        </> : <div className={styles.normal_wrap}>
          {
            items.map((item, index) => {
              return item.label !== "Welcome" && (
                <div key={index}>
                  <SectionTitle1 id={item.key}>
                    {item.label}
                  </SectionTitle1>
                  {
                    item.children?.map((child, index) => {
                      console.log('~ child', child);
                      return <div key={index}>
                        <SectionTitle2 id={child.key}>
                          {child.label}
                        </SectionTitle2>
                        <SectionTitle3>
                          {child.text}
                        </SectionTitle3>
                      </div>;
                    })
                  }
                  <SizeBox h={50}></SizeBox>
                </div>
              );
            })
          }
          <SizeBox h={100}></SizeBox>
        </div>
      }
      {
        !mobile &&  <div>
          <Footer className={"px-[20px]"}></Footer>
        </div>
      }
    </div>
    {/* <div onClick={openEmail} className={styles.contact_us}>*/}
    {/*  <MessageFilled />*/}
    {/* </div>*/}
    <CancelAuthModal show={outLoginVisible} onCancel={() => setOutLoginVisible(false)}></CancelAuthModal>
  </div >;
};


const WelcomeComp = ({ onMenu, randomList, items, mobile }) => {

  const [currentSearchList, setCurrentSearchList] = useState([]);

  const topics = [
    { title: 'New Influencers Guidence', key: "1", description: 'What is anyStarr', icon: 'https://static.xx.fbcdn.net/assets/?revision=1431132240730458&name=Illustrations-Get-Started&density=1' },
    { title: 'Q&A for Accounts', key: "2", description: 'What private information will you get?', icon: 'https://static.xx.fbcdn.net/assets/?revision=1431132240730458&name=Illustrations-Security&density=1' },
    { title: 'Q&A for Samples', key: "3", description: 'What can I do if I have reached the sample limit?', icon: 'https://static.xx.fbcdn.net/assets/?revision=1431132240730458&name=Illustrations-Backup&density=1' },
    { title: 'Q&A for Products', key: "4", description: 'How do I know the quality of products?', icon: 'https://static.xx.fbcdn.net/assets/?revision=1431132240730458&name=Illustrations-Backup&density=1' },
    { title: 'Q&A for Commissions', key: "5", description: 'Why I get low rate commissions and increase comissions?\n', icon: 'https://static.xx.fbcdn.net/assets/?revision=1431132240730458&name=Illustrations-Backup&density=1' },
    { title: 'Q&A for Logistics', key: "6", description: 'Why haven\'t I received my package?', icon: 'https://static.xx.fbcdn.net/assets/?revision=1431132240730458&name=Illustrations-Backup&density=1' },
  ];

  const onMenuClick = (e) => {
    window.location.href = `#${e.key}`;
  };

  const content = (
    <div style={{
      width: mobile ? 200 : 500
    }}>
      {
        currentSearchList.length > 0 ? currentSearchList.map((item, index) => {
          return <div key={index} style={{
            height: "40px",
            lineHeight: "40px",
            cursor: "pointer"
          }} onClick={() => onMenu(item)}>{item.title}</div>;
        }) : randomList.map((item, index) => {
          return <div key={index} style={{
            height: mobile ? "unset" : "40px",
            lineHeight: mobile ? "20px" : "40px",
            marginBottom: mobile ? 10 : 5,
            cursor: "pointer"
          }} onClick={() => onMenu(item)}>{item.title}</div>;
        })
      }
    </div>
  );

  const onChange = (e) => {
    if (!e.target.value) {
      setCurrentSearchList([]);
      return;
    }
    const cl = flattenSecondaryItems(items);
    const searchValue = e.target.value.toLowerCase(); // 将输入值转换为小写，确保不区分大小写

    // 筛选出与 searchValue 模糊匹配的内容
    const filteredList = cl.filter(item =>
      item.title.toLowerCase().includes(searchValue)
    );
    // 将筛选后的结果设置到 currentSearchList 中
    setCurrentSearchList(filteredList);
  };

  return (
    <div id={"0"} className={styles.welcome_container}>
      <h1>Welcome</h1>
      <SizeBox h={30} />
      <h1 className={styles.welcome_heading}>What is anyStarr?</h1>
      <SectionTitle3 className={styles.welcome_cardDescription}>Your One-Stop TikTok E-Commerce Platform</SectionTitle3>
      <SectionTitle3 className={styles.welcome_cardDescription}>As an official TikTok affiliate partner, anyStarr empowers creators to maximize their earnings with higher commissions, an extensive selection of high-quality products, and dedicated support for long-term success. Join anyStarr today and turn your TikTok influence into real revenue!</SectionTitle3>
      <SizeBox h={30} />
      <h1 className={styles.welcome_heading}>How can we help you?</h1>
      <Popover overlayInnerStyle={{
        width: mobile ? 210 : 500
      }} placement={"bottomLeft"} trigger={"click"} content={content}>
        <div className={styles.welcome_search}>
          <Input onChange={onChange} type={"text"} placeholder={"Search help articles..."} className={styles.welcome_searchInput} />
        </div>
      </Popover>
      <h4 className={styles.welcome_heading}>Popular Topics</h4>
      <div className={styles.welcome_topics}>
        {topics.map((topic, index) => (
          <div onClick={() => onMenuClick(topic)} key={index} className={styles.welcome_card}>
            {/* <img src={topic.icon} alt={topic.title} className={styles.welcome_icon} />*/}
            <h3 className={styles.welcome_cardTitle}>{topic.title}</h3>
            <p className={styles.welcome_cardDescription}>{topic.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};


const SectionTitle1 = ({ id, children }) => {
  return <div id={id} className={styles.section_title_1}>{children}</div>;
};

const SectionTitle2 = ({ id, children }) => {
  return <div id={id} className={styles.section_title_2}>{children}</div>;
};

const SectionTitle3 = ({ id, children }) => {
  return <div id={id} className={styles.section_title_3}>{children}</div>;
};

const HelpCenterIcon = ({ id }) => {
  return <img src={`helpCenter/${id}.png`} style={{ marginRight: "5px" }} width={25} height={25} />;
};

export default HelpCenter;
